<template>
  <div class="page-shell page-shell--deliver-apps">
    <section class="page-shell__content">
      <div class="page-shell__panel page-shell__tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="customTabs" type="border-card">
          <el-tab-pane
            v-for="item in tabList"
            :key="item.name"
            :label="item.label"
            :name="item.name"
          >
            <div class="page-shell__tab-pane">
              <public-table
                :column="getColumn"
                :tableData="deliveryList"
                :PageInfo="listQuery"
                :onAdd="() => (addDeliverAppShow = true)"
                addTitle="直接交付"
                :enableSearch="true"
                :searchItems="searchItems"
                @handlePaginationChange="handleSearchList"
              >
                <template v-slot:appName="{ row }">
                  <div>{{ row.appName }}</div>
                </template>
                <template v-slot:operate="{ row }">
                  <el-button size="mini" type="text" @click="showDetail(row)">
                    详情
                  </el-button>
                </template>
                <template v-slot:appState="{ row }">
                  <span
                    :style="{
                      color: handleAppState(row.appState, true)
                    }"
                  >
                    {{ handleAppState(row.appState) }}
                  </span>
                </template>
                <template v-slot:expiredTime="{ row }">{{
                  row.expiredTime ? timetrans(row.expiredTime) : '-'
                }}</template>
              </public-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>
    <DialogDeliver
      v-if="addDeliverAppShow"
      @handleClose="handleCloseAddDeliverAppShow"
      :dialogVisible="addDeliverAppShow"
      :marketID="marketID"
    />
  </div>
</template>
<script>
import {
  getDeliveryAppListApi,
  updateOrBuildAppApi,
  fetchDeliveryRegionList
} from '@/api/delivery';
import { fetchCustomerList } from '@/api/customer';
import { errorHandle } from '@/utils/error';
import { timetrans } from '@/utils/validate';
import { handleAppState } from '@/utils/dictionary';
import { handleRegion } from '@/utils/common';
import DialogDeliver from '@/components/Dialog/Deliver/index.vue';
import { fetchDeliveryAppStateOptions } from '@/utils/dictionary';
import { havePerm } from '../../../utils/auth';
const defaultListQuery = {
  page: 1,
  pageSize: 10,
  total: 0
};

export default {
  name: 'Appinfo',
  components: {
    DialogDeliver
  },
  data() {
    return {
      handleAppState,
      activeName: 'paas',
      tabList: [
        {
          name: 'paas',
          label: 'PaaS交付'
        }
      ],
      timetrans,
      listQuery: defaultListQuery,
      Loading: false,
      addDeliverAppShow: false,
      deliveryList: [],
      column: [
        {
          prop: 'appName',
          label: '应用名称',
          scopeStatus: true
        },
        {
          prop: 'appVersion',
          label: '版本',
          width: '80px'
        },
        {
          prop: 'comboName',
          label: '套餐名称'
        },
        {
          prop: 'customerName',
          label: '客户名称'
        },
        {
          prop: 'regionName',
          label: '交付环境名称'
        },
        {
          prop: 'tenantAlias',
          label: '租户名称'
        },
        {
          prop: 'expiredTime',
          label: '过期时间',
          width: '150px',
          scopeStatus: true
        },
        {
          prop: 'appState',
          label: '状态'
        },
        {
          prop: 'operate',
          label: '操作',
          scopeStatus: true
        }
      ],
      searchItems: [
        {
          label: '应用名称',
          name: 'appName',
          span: 7,
          value: '',
          type: 'input'
        },
        {
          label: '客户名称',
          name: 'customerID',
          value: '',
          type: 'select',
          span: 7,
          options: []
        },
        {
          label: '交付环境',
          name: 'regionID',
          value: '',
          type: 'selectgroup',
          span: 7,
          options: []
        },
        {
          label: '应用状态',
          name: 'status',
          value: '',
          type: 'select',
          span: 7,
          options: fetchDeliveryAppStateOptions()
        }
      ],
      timer: null
    };
  },
  created() {
    this.getDeliverAppsList();
    if (havePerm('Market.Customer.List')) {
      this.getCustomers();
    }
    this.getDeliverEnvs();
  },

  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    getColumn() {
      if (this.activeName == 'paas') {
        return [
          {
            prop: 'appName',
            label: '应用名称',
            scopeStatus: true
          },
          {
            prop: 'appVersion',
            label: '版本',
            width: '80px'
          },
          {
            prop: 'comboName',
            label: '套餐名称'
          },
          {
            prop: 'customerName',
            label: '客户名称'
          },
          {
            prop: 'regionName',
            label: '交付环境名称'
          },
          {
            prop: 'tenantAlias',
            label: '租户名称'
          },
          {
            prop: 'expiredTime',
            label: '过期时间',
            width: '150px',
            scopeStatus: true
          },
          {
            prop: 'appState',
            label: '状态',
            width: '150px',
            scopeStatus: true
          },
          {
            prop: 'operate',
            label: '操作',
            scopeStatus: true
          }
        ];
      }
      return [
        {
          prop: 'appName',
          label: '应用名称',
          scopeStatus: true
        },
        {
          prop: 'appVersion',
          label: '版本',
          width: '80px'
        },
        {
          prop: 'comboName',
          label: '套餐名称'
        },
        {
          prop: 'customerName',
          label: '客户名称'
        },
        {
          prop: 'expiredTime',
          label: '过期时间',
          width: '150px',
          scopeStatus: true
        },
        {
          prop: 'appState',
          label: '状态',
          width: '150px',
          scopeStatus: true
        },
        {
          prop: 'operate',
          label: '操作',
          scopeStatus: true
        }
      ];
    }
  },

  methods: {
    handleCloseAddDeliverAppShow() {
      this.getDeliverAppsList();
      this.addDeliverAppShow = false;
    },
    handleSearchList(data) {
      if (data) {
        this.listQuery = {
          ...this.listQuery,
          ...data
        };
      }
      this.getDeliverAppsList();
    },
    getDeliverAppsList() {
      this.listQuery.marketID = this.marketID;
      this.listQuery.deliveryType = this.activeName;
      getDeliveryAppListApi(this.listQuery)
        .then((res) => {
          if (res) {
            this.deliveryList = res.apps;
            this.listQuery.total = res.total;
          }
          this.timer && clearInterval(this.timer);
          // 加载轮询数据
          this.timer = setInterval(() => {
            this.getDeliverAppsList();
          }, 10000);
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    getCustomers() {
      fetchCustomerList({
        marketID: this.marketID,
        page: -1,
        pageSize: -1,
        simple: true
      })
        .then((res) => {
          if (res && res.customers) {
            const options = [];
            options.push({
              label: '全部',
              value: ''
            });
            res.customers.map((item) => {
              options.push({
                label: item.customerName,
                value: item.customerID
              });
            });
            this.searchItems.map((item) => {
              if (item.name == 'customerID') {
                item.options = options;
              }
            });
          }
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    getDeliverEnvs() {
      if (!havePerm('Deliver.Region.List')) {
        return;
      }
      fetchDeliveryRegionList({
        inUse: true,
        marketID: this.marketID,
        page: -1,
        pageSize: -1
      })
        .then((res) => {
          if (res) {
            if (res.regions) {
              const regionOptions = handleRegion(res.regions);
              regionOptions.unshift({
                label: '',
                options: [
                  {
                    label: '全部',
                    value: ''
                  }
                ]
              });
              this.searchItems.map((item) => {
                if (item.name == 'regionID') {
                  item.options = regionOptions;
                }
              });
            } else {
              this.deliveryRegions = [];
            }
          }
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    showDetail(row) {
      this.$router.push({
        name: 'deliverDetails',
        params: {
          deliverID: row.appID
        }
      });
    },
    updateOrBuildApp(data, opType) {
      this.$confirm(
        '确认继续执行' + (opType == 'build' ? '构建' : '更新') + '操作?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          updateOrBuildAppApi({
            marketID: this.marketID,
            appID: data.appID,
            type: opType
          })
            .then((res) => {
              this.$message.success('操作成功');
            })
            .catch((err) => {
              errorHandle(err);
            });
        })
        .catch(() => {});
    },
    handleClick() {
      this.getDeliverAppsList();
    }
  },
  destroyed() {
    // 组件销毁,清除定时器
    this.timer && clearInterval(this.timer);
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/page-shell.scss';
</style>



// WEBPACK FOOTER //
// src/views/deliverManage/apps/index.vue